// eslint-disable-next-line import/prefer-default-export
export function updateTillPayload(payload, status) {
  return {
    ...payload,
    id: `${payload.id}-${payload.tillNumber}-${payload.currencyCode}`, // update id to match current model
    originId: payload.id, // hold onto original id from response
    status, // optimistic update on successful response
  };
}
